import { put } from 'redux-saga/effects';
import caseCreationActions from 'redux/actions/caseCreationActions';
const { retryCreateCaseCount, createCaseStart } = caseCreationActions;

export function* caseCreationRetrySaga() {
  yield put(retryCreateCaseCount());
  yield put(createCaseStart());
}
